// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwMCIgd2lkdGg9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkYXRhLW5hbWU9IkxheWVyIDEiIHZpZXdCb3g9IjAgMCA1MCA1MCI+PHBhdGggZD0iTTQ4LjcxIDQyLjkxTDM0LjA4IDI4LjI5IDQ0LjMzIDE4YTEgMSAwIDAwLS4zMy0xLjYxTDIuMzUgMS4wNmExIDEgMCAwMC0xLjI5IDEuMjlMMTYuMzkgNDRhMSAxIDAgMDAxLjY1LjM2bDEwLjI1LTEwLjI4IDE0LjYyIDE0LjYzYTEgMSAwIDAwMS40MSAwbDQuMzgtNC4zOGExIDEgMCAwMC4wMS0xLjQyem0tNS4wOSAzLjY3TDI5IDMyYTEgMSAwIDAwLTEuNDEgMGwtOS44NSA5Ljg1TDMuNjkgMy42OWwzOC4xMiAxNEwzMiAyNy41OEExIDEgMCAwMDMyIDI5bDE0LjU5IDE0LjYyeiIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMy4yNSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9hbmd1bGFyXzEwNzJfNTIzNDMpIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8ZGVmcz4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDBfYW5ndWxhcl8xMDcyXzUyMzQzIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkgcm90YXRlKC0xODApIHNjYWxlKDQpIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzlBQTRCMiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5QUE0QjIiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgOEM2LjIwOTE0IDggOCA2LjIwOTE0IDggNEM4IDEuNzkwODYgNi4yMDkxNCAwIDQgMEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNEMwIDYuMjA5MTQgMS43OTA4NiA4IDQgOFpNNS44NTM1NSAzLjM1MzU1QzYuMDQ4ODIgMy4xNTgyOSA2LjA0ODgyIDIuODQxNzEgNS44NTM1NSAyLjY0NjQ1QzUuNjU4MjkgMi40NTExOCA1LjM0MTcxIDIuNDUxMTggNS4xNDY0NSAyLjY0NjQ1TDMuNSA0LjI5Mjg5TDIuODUzNTUgMy42NDY0NUMyLjY1ODI5IDMuNDUxMTggMi4zNDE3MSAzLjQ1MTE4IDIuMTQ2NDUgMy42NDY0NUMxLjk1MTE4IDMuODQxNzEgMS45NTExOCA0LjE1ODI5IDIuMTQ2NDUgNC4zNTM1NUwzLjE0NjQ1IDUuMzUzNTVDMy4zNDE3MSA1LjU0ODgyIDMuNjU4MjkgNS41NDg4MiAzLjg1MzU1IDUuMzUzNTVMNS44NTM1NSAzLjM1MzU1WiIgZmlsbD0iIzlBQTRCMiIvPgo8L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgOEM2LjIwOTE0IDggOCA2LjIwOTE0IDggNEM4IDEuNzkwODYgNi4yMDkxNCAwIDQgMEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNEMwIDYuMjA5MTQgMS43OTA4NiA4IDQgOFpNNS44NTM1NSAzLjM1MzU1QzYuMDQ4ODIgMy4xNTgyOSA2LjA0ODgyIDIuODQxNzEgNS44NTM1NSAyLjY0NjQ1QzUuNjU4MjkgMi40NTExOCA1LjM0MTcxIDIuNDUxMTggNS4xNDY0NSAyLjY0NjQ1TDMuNSA0LjI5Mjg5TDIuODUzNTUgMy42NDY0NUMyLjY1ODI5IDMuNDUxMTggMi4zNDE3MSAzLjQ1MTE4IDIuMTQ2NDUgMy42NDY0NUMxLjk1MTE4IDMuODQxNzEgMS45NTExOCA0LjE1ODI5IDIuMTQ2NDUgNC4zNTM1NUwzLjE0NjQ1IDUuMzUzNTVDMy4zNDE3MSA1LjU0ODgyIDMuNjU4MjkgNS41NDg4MiAzLjg1MzU1IDUuMzUzNTVMNS44NTM1NSAzLjM1MzU1WiIgZmlsbD0iIzIyQzU1RSIvPgo8L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-sec-sdk- {
  font-family: "Lato", sans-serif;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px #a8c8dd;
  display: flex;
  align-items: center;
  padding: 15px 20px;
}

.header-sec-sdk- .name-agent {
  font-family: "Lato", sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: #26344A;
  line-height: 19px;
  padding-left: 15px;
}

@-webkit-keyframes slideInRightVAbox {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInRightVAbox {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
.initial-video-audio-container {
  -webkit-animation-name: slideInRightVAbox;
  animation-name: slideInRightVAbox;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  right: 56px;
  display: flex;
  align-items: center;
  z-index: 100000;
  top: 118px;
  position: fixed;
  width: 340px;
  border-radius: 4px;
  border: 1px solid var(--gray-modern-200, #E3E8EF);
  background: var(--gray-modern-100, #EEF2F6);
  padding: 16px;
  font-family: "Inter";
  flex-direction: column;
  gap: 8px;
}

/* Co browser styles */
.initial-video-audio-container.cobrowser-intial-width {
  width: 270px;
  margin: 16px auto;
  position: fixed !important;
  /* right: 30px !important; */
  top: 130px !important;
  z-index: 99999;
  margin: 0;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  border-radius: 6px;
  background: var(--gray-modern-500, #697586);
  width: 370px;
  padding: 12px;
}

.initial-video-audio-container.cobrowser-intial-width .ad-img-block {
  border: 0;
  flex-shrink: 0;
}

.initial-video-audio-container.cobrowser-intial-width .ad-img-block img {
  border: 0;
}

.initial-video-audio-container.cobrowser-intial-width .content-desc {
  text-align: left;
}

.initial-video-audio-container.cobrowser-intial-width .content-desc .name {
  color: var(--generic-white, #FFF);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
}

.initial-video-audio-container.cobrowser-intial-width .content-desc .type-text {
  color: var(--generic-white, #FFF);
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
}

.initial-video-audio-container.cobrowser-intial-width .controls-v-a {
  margin: 0;
}

.initial-video-audio-container.cobrowser-intial-width .controls-v-a img {
  display: block;
  margin: 0;
}

.cobrowse-toolbar {
  display: flex;
  align-items: flex-start;
  z-index: 100000;
  cursor: move;
  width: 40px;
  height: 172px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
}

.cobrowse-btn {
  cursor: pointer;
  width: 30px;
  height: 30px;
  background: #F5F8FA;
  border-radius: 2px;
}

.cobrowse-btn :hover {
  background: #E9EFF4;
}

.toolbar-image {
  width: 30px;
  height: 30px;
}

@-webkit-keyframes slideOutUpcobrowser {
  0% {
    -webkit-transform: translateY(60px);
    transform: translateY(60px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slideOutUpcobrowser {
  0% {
    -webkit-transform: translateY(60px);
    transform: translateY(60px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
.avatar-actions:hover .cobrowser-wrapper-elipse .elipse-btn {
  display: block;
}

.avatar-actions .cobrowser-wrapper-elipse {
  position: absolute;
  right: -25px;
  display: flex;
  flex-direction: column;
  width: auto;
  height: auto;
  top: auto;
  bottom: 10px;
  padding-left: 10px;
}

.avatar-actions .cobrowser-wrapper-elipse.open-cobrowser .elipse-btn {
  display: block !important;
}

.avatar-actions .cobrowser-wrapper-elipse.open-cobrowser .co-bowser-options {
  display: block;
}

.avatar-actions .cobrowser-wrapper-elipse.open-input-browse .co-bowser-options .input-box-co-browser {
  display: block;
}

.avatar-actions .cobrowser-wrapper-elipse .elipse-btn {
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: none;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options {
  position: absolute;
  top: -78px;
  left: -35px;
  display: none;
  -webkit-animation-name: slideOutUpcobrowser;
  animation-name: slideOutUpcobrowser;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .btn-co-browser {
  border-radius: 32px;
  background: var(--bot-colors-intent, #4B4EDE);
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.1), 0px 4px 6px -1px rgba(16, 24, 40, 0.1);
  display: inline-flex;
  height: 34px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  width: 34px;
  cursor: pointer;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser {
  position: absolute;
  bottom: auto;
  top: -115px;
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0px 4px 6px -4px rgba(16, 24, 40, 0.1), 0px 10px 15px -3px rgba(16, 24, 40, 0.1);
  display: flex;
  width: 363px;
  padding: 24px 12px;
  flex-direction: column;
  left: auto;
  right: 0;
  display: none;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser .label-text {
  color: var(--neutral-900, #171717);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 4px;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input {
  height: 40px;
  padding: 8px 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  border-radius: 8px !important;
  border: 1px solid var(--gray-300, #D0D5DD);
  background: var(--base-white, #FFF);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: var(--gray-900, #101828);
  outline: 0;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input::placeholder {
  color: var(--gray-500, #667085);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:focus {
  border: 1px solid var(--primary-300, #84ADFF);
  box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:active {
  border: 1px solid var(--primary-300, #84ADFF);
  box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:disabled {
  border: 1px solid var(--gray-300, #D0D5DD);
  background: var(--gray-50, #F9FAFB);
  pointer-events: none;
  cursor: not-allowed;
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input.error {
  border: 1px solid var(--error-300, #FDA29B);
  background: var(--base-white, #FFF);
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input.error:focus {
  box-shadow: 0px 0px 0px 4px #FEE4E2, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:read-only {
  border: 1px solid var(--gray-300, #D0D5DD);
  background: var(--gray-50, #F9FAFB);
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:-moz-read-only {
  border: 1px solid var(--gray-300, #D0D5DD);
  background: var(--gray-50, #F9FAFB);
}

.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser .error-msg {
  color: var(--error-500, #F04438);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 4px;
}

/* End */
.initial-video-audio-container .ad-img-block {
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin-bottom: 6px;
}

.initial-video-audio-container .ad-img-block img {
  width: 48px;
  height: 48px;
  border: 1px solid #fff;
  border-radius: 100%;
}

.initial-video-audio-container .content-desc {
  text-align: center;
}

.initial-video-audio-container .content-desc .name {
  margin-bottom: 4px;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.initial-video-audio-container .content-desc .type-text {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-modern-500, #697586);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  gap: 5px;
}

.initial-video-audio-container .controls-v-a {
  gap: 8px;
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.initial-video-audio-container .controls-v-a button {
  display: flex;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border: 0;
  color: var(--destructive-50, #FEF2F2);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  height: 26px;
  border-radius: 4px;
  cursor: pointer;
}

.initial-video-audio-container .controls-v-a button.decline-btn {
  background: var(--destructive-500-main, #EF4444);
}

.initial-video-audio-container .controls-v-a button.accept-btn {
  background: var(--success-600, #16A34A);
}

.video-audio-chat-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--gray-modern-200, #E3E8EF);
  background: var(--gray-modern-100, #EEF2F6);
}

.video-audio-chat-container.video {
  border: 0;
}

.video-audio-chat-container.video .video-chat- {
  background: #000;
}

.video-audio-chat-container.video .video-chat- .video-view- .video-name-title {
  color: #FFFFFF !important;
}

.video-audio-chat-container.video .video-chat- .video-view- .title {
  color: #FFFFFF !important;
}

.video-audio-chat-container.video #callbuttons {
  position: absolute;
  bottom: 20px;
}

.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.active- .mute-audio {
  background: var(--bot-colors-intent, #4B4EDE);
  border: 1px solid var(--bot-colors-intent, #4B4EDE);
}

.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions .mute-audio {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(2px);
  border: 0 !important;
}

.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions .mute-audio .mute-img svg path {
  fill: #fff;
}

.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(2px);
}

.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video {
  background: var(--bot-colors-intent, #4B4EDE);
  border: 1px solid var(--bot-colors-intent, #4B4EDE);
  border: 0 !important;
}

.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video .video-mute svg path {
  stroke: #fff;
}

.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions p {
  color: var(--generic-white, #FFF);
}

.video-audio-chat-container .video-chat- {
  width: 100%;
}

.video-audio-chat-container .video-chat- .video-view- {
  width: 100%;
  position: relative;
  height: 250px;
}

.video-audio-chat-container .video-chat- .video-view-.audio-view- {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  padding: 16px;
  height: auto;
}

.video-audio-chat-container .video-chat- .video-view-.audio-view- .agent-profile-img {
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin-bottom: 6px;
}

.video-audio-chat-container .video-chat- .video-view-.audio-view- .agent-profile-img img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 1px solid #fff;
}

.video-audio-chat-container .video-chat- .video-view-.audio-view- .video-name-title {
  color: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.video-audio-chat-container .video-chat- .video-view-.audio-view- .title {
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}

.video-audio-chat-container .video-chat- .video-view-.audio-view- .audio-info {
  color: var(--gray-modern-500, #697586);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.video-audio-chat-container .video-chat- .video-view- video {
  width: 100%;
  border-radius: 4px;
  background: #000;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container {
  position: absolute;
  width: 158px;
  height: 60px;
  cursor: move;
  border-radius: 5px;
  background: transparent;
  z-index: 1;
  top: 10px !important;
  left: 0 !important;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container.minimize-video {
  width: 40px !important;
  height: 43px !important;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .close-video {
  border-radius: 64px;
  background: rgba(18, 19, 20, 0.6);
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  top: -7px;
  right: 25px;
  cursor: pointer;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .close-video svg path {
  fill: #fff;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video {
  position: absolute;
  bottom: 5px;
  width: 34px;
  height: 34px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  cursor: pointer;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video.off-on-action .t-off {
  display: block;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video.off-on-action .t-on {
  display: none;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video .t-off {
  display: none;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video .t-on {
  display: block;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .self-video {
  border-radius: 4px;
  box-shadow: 0px 25px 26px 0px rgba(32, 33, 36, 0.17);
  height: 100%;
  width: 100%;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .self-video .video-user-alphabet {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFBEB6;
  border: 2px solid #fff;
  border-radius: 100%;
  color: #000000;
  font-weight: bold;
  font-size: 10px;
  line-height: 29px;
  margin: 0 auto;
  position: absolute;
  top: 0;
  right: 0;
  left: 10px;
  bottom: 0;
}

.video-audio-chat-container .video-chat- .video-view- .self-video-container .self-video video {
  width: 158px;
  height: 60px;
  background: transparent;
}

.video-audio-chat-container .footer-btn-a-v-attch {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video {
  border-radius: 50.82px;
  display: flex;
  width: 45px;
  height: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: var(--bot-colors-intent, #4B4EDE);
  border: 1px solid var(--bot-colors-intent, #4B4EDE);
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video span {
  line-height: 0px;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video span.video-unmute {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video span.video-mute {
  display: none;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video {
  border: 0.508px solid var(--neutral-300, #D4D4D4);
  background: var(--kore-grey-kore-white, #FFF);
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video span.video-unmute {
  display: none;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video span.video-mute {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- p.video-off {
  display: none;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- p.video-on {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper p.video-off {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper p.video-on {
  display: none;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- .mute-audio {
  background: var(--bot-colors-intent, #4B4EDE);
  border: 1px solid var(--bot-colors-intent, #4B4EDE);
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- .mute-audio span.mute-img {
  display: none;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- .mute-audio span.un-mute {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- p.mute-text {
  display: none;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- p.un-mute-text {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .enable-audio {
  display: flex;
  width: 45px;
  height: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50.82px;
  background: var(--destructive-500-main, #EF4444);
  border: 0;
  padding: 0;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions p {
  color: var(--generic-black, #000);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions p.mute-text {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions p.un-mute-text {
  display: none;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio {
  border-radius: 50.82px;
  border: 0.508px solid var(--neutral-300, #D4D4D4);
  background: var(--kore-grey-kore-white, #FFF);
  display: flex;
  width: 45px;
  height: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio span {
  line-height: 0px;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio span.mute-img {
  display: block;
}

.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio span.un-mute {
  display: none;
}

.video-audio-chat-container .action-minimize-audio-control {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info {
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
  border-radius: var(--full, 9999px);
  border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-utility-error-utility-error-200, #FECDCA);
  background: var(--component-colors-utility-error-utility-error-50, #FEF3F2);
  padding: var(--xxs, 2px) var(--default, 8px);
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info.recording-info-paused {
  border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-utility-gray-utility-gray-200, #EAECF0);
  background: var(--component-colors-utility-gray-utility-gray-50, #F9FAFB);
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info.recording-info-paused svg path {
  fill: #98A2B3;
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info.recording-info-paused p {
  color: var(--component-colors-utility-gray-utility-gray-700, #344054);
  text-align: center;
  font-size: var(--font-size-text-xs, 12px);
  font-weight: var(--font-weight-normal-Medium, 500);
  line-height: var(--font-line-height-text-xs, 16px); /* 133.333% */
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info .recording-tooltip {
  position: absolute;
  top: -42px;
  width: 180px;
  left: -75px;
  height: auto;
  margin: 0 auto;
  border-radius: var(--default, 8px);
  background: var(--colors-background-bg-primary-solid, #0C111D);
  padding: var(--default, 8px) var(--md, 12px);
  color: var(--colors-text-text-white, #FFF);
  text-align: center;
  font-size: var(--font-size-text-xs, 12px);
  font-weight: var(--font-weight-normal-Semibold, 600);
  line-height: var(--font-line-height-text-xs, 16px);
  opacity: 0;
  visibility: hidden;
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info .recording-tooltip::before {
  content: "";
  position: absolute;
  bottom: -5px;
  width: 10px;
  height: 10px;
  background: var(--colors-background-bg-primary-solid, #0C111D);
  left: 96px;
  margin: 0 auto;
  transform: rotate(45deg);
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info:hover .recording-tooltip {
  opacity: 1;
  visibility: visible;
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info svg {
  flex-shrink: 0;
}

.video-audio-chat-container .action-minimize-audio-control .recording-video-info p {
  color: var(--component-colors-utility-error-utility-error-700, #B42318);
  text-align: center;
  font-size: var(--font-size-text-xs, 12px);
  font-weight: var(--font-weight-normal-Medium, 500);
  line-height: var(--font-line-height-text-xs, 16px);
}

.video-audio-chat-container .action-minimize-audio-control .maximize-video {
  border-radius: 100%;
  cursor: pointer;
  margin-bottom: 15px;
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 64px;
  background: rgba(18, 19, 20, 0.6);
  margin: 0;
}

.video-audio-chat-container .action-minimize-audio-control .maximize-video .maximize-icon {
  display: block;
}

.video-audio-chat-container .action-minimize-audio-control .maximize-video .minimize-icon {
  display: none;
}

.video-audio-chat-container .show-self-video-container {
  position: absolute;
  top: 40px;
  right: 10px;
}

.video-audio-chat-container .show-self-video-container .show-self-video {
  border-radius: 100%;
  cursor: pointer;
  margin-bottom: 15px;
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 64px;
  background: rgba(18, 19, 20, 0.6);
  margin: 0;
}

#agentcontainer {
  height: auto !important;
}

/*
 * Native fullscreen is requested on the chat window so call controls,
 * recording consent UI, and notifications remain in the fullscreen subtree.
 */
.kore-chat-window:fullscreen {
  width: 100%;
  min-width: 0;
  max-height: none;
  height: 100%;
  bottom: 0;
  right: 0;
  border: 0;
  border-radius: 0;
}

.kore-chat-window:fullscreen #agentcontainer.full-screen-video {
  top: 0;
  left: 0;
}

#agentcontainer.full-screen-video {
  position: absolute;
  width: 100%;
  height: 100% !important;
  z-index: 9;
  padding: 0;
}

#callcontainer {
  position: relative;
  padding: 10px 16px 16px 16px;
}

#agentcontainer.full-screen-video #callcontainer {
  height: 100%;
  padding: 0;
}

#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container {
  height: 100%;
}

#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- {
  height: 100%;
}

#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- #audiovideocallcontainer {
  height: 100%;
}

#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- #audiovideocallcontainer .video-view- {
  height: 100%;
}

#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- #audiovideocallcontainer .video-view- video {
  height: 100%;
  /* background: linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0) 68.49%,#000 100%); */
}

#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .action-minimize-audio-control .maximize-video .maximize-icon {
  display: none;
}

#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .action-minimize-audio-control .maximize-video .minimize-icon {
  display: block;
}

.system-template {
  position: relative;
  border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);
  margin-bottom: 30px;
  font-weight: 400;
  margin-top: 20px;
  text-align: center;
}

.system-template-msg {
  position: relative;
  top: 8px;
  background: var(--sdk-chat-widow-default-white);
  padding: 0px 10px;
  display: initial;
  width: 137px;
  color: #333;
  margin-left: 0;
  margin-top: 43x;
  font-weight: bold;
  font-size: 12px;
}

.agent-mouse {
  position: absolute;
  z-index: 10000;
  width: 20px;
  height: 20px;
  transition: left 0.05s linear, top 0.05s linear;
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-color: transparent;
}

.agent-mouse-circle {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #4950f6;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  opacity: 0.3;
}

.rr-block {
  border: 1px solid red !important;
  background: transparent;
}

.agent-bot {
  display: block;
  background: #009dab;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  padding: 6px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  position: fixed;
  right: 0;
}

/*********************** rrweb css ******************************************/
.replayer-wrapper {
  position: relative;
}

.replayer-mouse {
  position: absolute;
  width: 20px;
  height: 20px;
  transition: left 0.05s linear, top 0.05s linear;
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-color: transparent;
}

.replayer-mouse:after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #4950f6;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  opacity: 0.3;
}

.replayer-mouse.active:after {
  animation: click 0.2s ease-in-out 1;
}

.replayer-mouse.touch-device {
  background-image: none;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  margin-left: -37px;
  margin-top: -37px;
  border: 4px solid rgba(73, 80, 246, 0);
  transition: left 0s linear, top 0s linear, border-color 0.2s ease-in-out;
}

.replayer-mouse.touch-device.touch-active {
  border-color: #4950f6;
  transition: left 0.25s linear, top 0.25s linear, border-color 0.2s ease-in-out;
}

.replayer-mouse.touch-device:after {
  opacity: 0;
}

.replayer-mouse.touch-device.active:after {
  animation: touch-click 0.2s ease-in-out 1;
}

.replayer-mouse-tail {
  position: absolute;
  pointer-events: none;
}

@keyframes click {
  0% {
    opacity: 0.3;
    width: 20px;
    height: 20px;
  }
  50% {
    opacity: 0.5;
    width: 10px;
    height: 10px;
  }
}
@keyframes touch-click {
  0% {
    opacity: 0;
    width: 20px;
    height: 20px;
  }
  50% {
    opacity: 0.5;
    width: 10px;
    height: 10px;
  }
}

.kore-chat-window ul.chat-container li.fromCurrentUser .extra-info {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row-reverse;
}

li.fromCurrentUser .sentIndicator {
  position: relative;
  top: 1px;
  margin-right: 5px;
  width: 12px;
  height: 12px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

li.fromCurrentUser .sentIndicator.delivered {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

li.fromCurrentUser .sentIndicator.read {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

#cobrowse-toolbar.rr-block {
  border-radius: 6px !important;
  background: var(--gray-modern-50, #F8FAFC) !important;
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.1), 0px 4px 6px -1px rgba(16, 24, 40, 0.1) !important;
  padding: 0 !important;
  height: auto !important;
  display: flex !important;
  padding: 12px 8px !important;
  flex-direction: column;
  align-items: center !important;
  gap: 16px;
}

#cobrowse-toolbar.rr-block[do-not-mutate] [do-not-mutate] {
  padding: 0 !important;
  background: transparent !important;
  width: 16px !important;
  height: 16px !important;
  margin: 0 auto !important;
}

#cobrowse-toolbar.rr-block[do-not-mutate] [do-not-mutate] img {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.kore-chat-window-main-section.minimize-chat .chat-widgetwrapper-main-container.rr-block {
  border: 0 !important;
  width: auto !important;
  height: auto !important;
}

div .agent-bubble-comp .agent-bubble-content .bottom-info .sent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 8px;
  height: 8px;
  background-repeat: no-repeat;
  background-position: center;
}

div .agent-bubble-comp .agent-bubble-content .bottom-info .sent.hide {
  display: none;
}

div .agent-bubble-comp .agent-bubble-content .bottom-info .delivered {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 8px;
  height: 8px;
  background-repeat: no-repeat;
  background-position: center;
}

div .agent-bubble-comp .agent-bubble-content .bottom-info .read {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  width: 8px;
  height: 8px;
  background-repeat: no-repeat;
  background-position: center;
}

.campaign-calling-audio-static-wrapper {
  margin: 4px 16px;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Gray-Modern-200, #e3e8ef);
  background: var(--Gray-Modern-100, #eef2f6);
  gap: 0;
}

.campaign-calling-audio-static-wrapper .icon_block {
  border-radius: 58.333px;
  border: 2.333px solid var(--Generic-White, #fff);
  background: var(--Primary-50, #eaf1fc);
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2.333px 3.5px -2.333px rgba(16, 24, 40, 0.1), 0px 5.833px 8.75px -1.75px rgba(16, 24, 40, 0.1);
  margin-bottom: 6px;
}

.campaign-calling-audio-static-wrapper h1 {
  color: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}

.campaign-calling-audio-static-wrapper p {
  display: flex;
  align-items: center;
  color: var(--Gray-Modern-500, #697586);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  gap: 6px;
  margin-top: 4px;
}

.campaign-calling-audio-static-wrapper p svg {
  flex-shrink: 0;
}

.campaign-calling-audio-static-wrapper p span {
  width: 100%;
}

.campaign-calling-audio-static-wrapper .button-cancel-div {
  margin-top: 12px;
}

.campaign-calling-audio-static-wrapper .button-cancel-div .btn-cancel-btn {
  height: 30px;
  min-width: 110px;
  color: var(--Primary-600, #155eef);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

html.rrweb-paused * {
  animation-play-state: running !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/agentDesktop/agentdesktop.css"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AACA;EACI,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAEJ;;AACA;EACI;IACI,mCAAA;IACA,2BAAA;IACA,mBAAA;EAEN;EAAE;IACI,gCAAA;IACA,wBAAA;EAEN;AACF;AAAA;EACI;IACI,mCAAA;IACA,2BAAA;IACA,mBAAA;EAEN;EAAE;IACI,gCAAA;IACA,wBAAA;EAEN;AACF;AACA;EACI,yCAAA;EACA,iCAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,2CAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,QAAA;AACJ;;AAEA,sBAAA;AACA;EACI,YAAA;EACA,iBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,aAAA;AACJ;;AACA;EACI,SAAA;EACA,cAAA;AAEJ;;AAAA;EACI,SAAA;AAGJ;;AADA;EACI,gBAAA;AAIJ;;AAFA;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAKJ;;AAHA;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAMJ;;AAJA;EACI,SAAA;AAOJ;;AALA;EACI,cAAA;EACA,SAAA;AAQJ;;AALA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;AAQJ;;AANA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EAEA,mBAAA;EACA,kBAAA;AAQJ;;AANA;EACI,mBAAA;AASJ;;AAPA;EACI,WAAA;EACA,YAAA;AAUJ;;AANA;EACI;IACI,mCAAA;IACA,2BAAA;IACA,UAAA;EASN;EANE;IACI,gCAAA;IACA,wBAAA;IACA,UAAA;EAQN;AACF;AALA;EACI;IACI,mCAAA;IACA,2BAAA;IACA,UAAA;EAON;EAJE;IACI,gCAAA;IACA,wBAAA;IACA,UAAA;EAMN;AACF;AAHA;EACI,cAAA;AAKJ;;AAHA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AAMJ;;AAJA;EACI,yBAAA;AAOJ;;AALA;EACI,cAAA;AAQJ;;AANA;EACI,cAAA;AASJ;;AAPA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAUJ;;AARA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,2CAAA;EACA,mCAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AAWJ;;AATA;EACI,mBAAA;EACA,6CAAA;EACA,0FAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAYJ;;AAVA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,4FAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;AAaJ;;AAXA;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAcJ;;AAZA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,0CAAA;EACA,mCAAA;EACA,kDAAA;EACA,+BAAA;EACA,UAAA;AAeJ;;AAbA;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAgBJ;;AAdA;EACI,6CAAA;EACA,2EAAA;AAiBJ;;AAfA;EACI,6CAAA;EACA,2EAAA;AAkBJ;;AAhBA;EACI,0CAAA;EACA,mCAAA;EACA,oBAAA;EACA,mBAAA;AAmBJ;;AAjBA;EACI,2CAAA;EACA,mCAAA;AAoBJ;;AAlBA;EACI,2EAAA;AAqBJ;;AAnBA;EACI,0CAAA;EACA,mCAAA;AAsBJ;;AApBA;EACI,0CAAA;EACA,mCAAA;AAuBJ;;AArBA;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAwBJ;;AAtBA,QAAA;AAEA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAwBJ;;AAtBA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AAyBJ;;AAvBA;EACI,kBAAA;AA0BJ;;AAxBA;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA2BJ;;AAzBA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;AA4BJ;;AA1BA;EACI,QAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA6BJ;;AA3BA;EACI,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA8BJ;;AA5BA;EACI,gDAAA;AA+BJ;;AA7BA;EACI,uCAAA;AAgCJ;;AA7BA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,2CAAA;AAgCJ;;AA9BA;EACI,SAAA;AAiCJ;;AA/BA;EACI,gBAAA;AAkCJ;;AA/BA;EACI,yBAAA;AAkCJ;;AAhCA;EACI,yBAAA;AAmCJ;;AAjCA;EACI,kBAAA;EACA,YAAA;AAoCJ;;AAlCA;EACI,6CAAA;EACA,mDAAA;AAqCJ;;AAnCA;EACI,oCAAA;EACA,0BAAA;EACA,oBAAA;AAsCJ;;AApCA;EACI,UAAA;AAuCJ;;AArCA;EACI,oCAAA;EACA,0BAAA;AAwCJ;;AAtCA;EACI,6CAAA;EACA,mDAAA;EACA,oBAAA;AAyCJ;;AAvCA;EACI,YAAA;AA0CJ;;AAxCA;EACI,iCAAA;AA2CJ;;AAzCA;EACI,WAAA;AA4CJ;;AA1CA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AA6CJ;;AA3CA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AA8CJ;;AA5CA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA+CJ;;AA7CA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAgDJ;;AA9CA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAiDJ;;AA/CA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAkDJ;;AAhDA;EACI,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAmDJ;;AAjDA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AAoDJ;;AAlDA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;AAqDJ;;AAnDA;EACI,sBAAA;EACA,uBAAA;AAsDJ;;AApDA;EACI,mBAAA;EACA,iCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAuDJ;;AArDA;EACI,UAAA;AAwDJ;;AAtDA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AAyDJ;;AAvDA;EACI,cAAA;AA0DJ;;AAxDA;EACI,aAAA;AA2DJ;;AAzDA;EACI,aAAA;AA4DJ;;AA1DA;EACI,cAAA;AA6DJ;;AA3DA;EACI,kBAAA;EACA,oDAAA;EACA,YAAA;EACA,WAAA;AA8DJ;;AA5DA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AA+DJ;;AA7DA;EACI,YAAA;EACA,YAAA;EACA,uBAAA;AAgEJ;;AA9DA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AAiEJ;;AA/DA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAkEJ;;AAhEA;EACI,sBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,6CAAA;EACA,mDAAA;AAmEJ;;AAjEA;EACI,gBAAA;AAoEJ;;AAlEA;EACI,cAAA;AAqEJ;;AAnEA;EACI,aAAA;AAsEJ;;AApEA;EACI,iDAAA;EACA,6CAAA;AAuEJ;;AArEA;EACI,aAAA;AAwEJ;;AAtEA;EACI,cAAA;AAyEJ;;AAvEA;EACI,aAAA;AA0EJ;;AAxEA;EACI,cAAA;AA2EJ;;AAzEA;EACI,cAAA;AA4EJ;;AA1EA;EACI,aAAA;AA6EJ;;AA3EA;EACI,6CAAA;EACA,mDAAA;AA8EJ;;AA5EA;EACI,aAAA;AA+EJ;;AA7EA;EACI,cAAA;AAgFJ;;AA9EA;EACI,aAAA;AAiFJ;;AA/EA;EACI,cAAA;AAkFJ;;AAhFA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gDAAA;EACA,SAAA;EACA,UAAA;AAmFJ;;AAjFA;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAoFJ;;AAlFA;EACI,cAAA;AAqFJ;;AAnFA;EACI,aAAA;AAsFJ;;AApFA;EACI,sBAAA;EACA,iDAAA;EACA,6CAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAuFJ;;AArFA;EACI,gBAAA;AAwFJ;;AAtFA;EACI,cAAA;AAyFJ;;AAvFA;EACI,aAAA;AA0FJ;;AAxFA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA2FJ;;AAzFA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kCAAA;EACA,gHAAA;EACA,2EAAA;EACA,4CAAA;AA4FJ;;AA1FA;EACI,8GAAA;EACA,yEAAA;AA6FJ;;AA3FA;EACI,aAAA;AA8FJ;;AA5FA;EACI,qEAAA;EACA,kBAAA;EACA,yCAAA;EACA,kDAAA;EACA,kDAAA,EAAA,aAAA;AA+FJ;;AA7FA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EACA,8DAAA;EACA,4CAAA;EACA,0CAAA;EACA,kBAAA;EACA,yCAAA;EACA,oDAAA;EACA,kDAAA;EACA,UAAA;EACA,kBAAA;AAgGJ;;AA9FA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,UAAA;EACA,cAAA;EACA,wBAAA;AAiGJ;;AA9FA;EACI,UAAA;EACA,mBAAA;AAiGJ;;AA9FA;EACI,cAAA;AAiGJ;;AA9FA;EACI,uEAAA;EACA,kBAAA;EACA,yCAAA;EACA,kDAAA;EACA,kDAAA;AAiGJ;;AA/FA;EACI,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iCAAA;EACA,SAAA;AAkGJ;;AAhGA;EACI,cAAA;AAmGJ;;AAjGA;EACI,aAAA;AAoGJ;;AAlGA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AAqGJ;;AAnGA;EACI,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iCAAA;EACA,SAAA;AAsGJ;;AAnGA;EACI,uBAAA;AAsGJ;;AAnGA;;;EAAA;AAIA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AAsGJ;;AAnGA;EACI,MAAA;EACA,OAAA;AAsGJ;;AAnGA;EACI,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;AAsGJ;;AApGA;EACI,kBAAA;EACA,4BAAA;AAuGJ;;AArGA;EACI,YAAA;EACA,UAAA;AAwGJ;;AAtGA;EACI,YAAA;AAyGJ;;AAvGA;EACI,YAAA;AA0GJ;;AAxGA;EACI,YAAA;AA2GJ;;AAzGA;EACI,YAAA;AA4GJ;;AA1GA;EACI,YAAA;EACA,yFAAA;AA6GJ;;AA3GA;EACI,aAAA;AA8GJ;;AA5GA;EACI,cAAA;AA+GJ;;AA5GA;EACI,kBAAA;EACA,mEAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA+GJ;;AA5GA;EACI,kBAAA;EACA,QAAA;EACA,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA+GJ;;AA5GA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;EACA,yDAAA;EACA,yBAAA;AA+GJ;;AA7GA;EACI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;AAgHJ;;AA7GA;EACI,gCAAA;EACA,uBAAA;AAgHJ;;AA7GA;EACI,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;AAgHJ;;AA9GA,6EAAA;AACA;EAAkB,kBAAA;AAkHlB;;AAlHoC;EAAgB,kBAAA;EAAkB,WAAA;EAAW,YAAA;EAAY,+CAAA;EAA4C,wBAAA;EAAwB,wBAAA;EAAwB,4BAAA;EAA4B,yDAAA;EAAmkB,yBAAA;AA8HxxB;;AA9HizB;EAAsB,WAAA;EAAW,qBAAA;EAAqB,WAAA;EAAW,YAAA;EAAY,mBAAA;EAAmB,mBAAA;EAAmB,gCAAA;EAA+B,YAAA;AAyIn8B;;AAzI88B;EAA6B,mCAAA;AA6I3+B;;AA7I6gC;EAA6B,sBAAA;EAAsB,WAAA;EAAW,YAAA;EAAY,mBAAA;EAAmB,kBAAA;EAAkB,iBAAA;EAAiB,sCAAA;EAAmC,wEAAA;AAwJhrC;;AAxJqvC;EAA0C,qBAAA;EAAqB,8EAAA;AA6JpzC;;AA7J63C;EAAmC,UAAA;AAiKh6C;;AAjK06C;EAA0C,yCAAA;AAqKp9C;;AArK4/C;EAAqB,kBAAA;EAAkB,oBAAA;AA0KniD;;AA1KujD;EAAiB;IAAG,YAAA;IAAW,WAAA;IAAW,YAAA;EAiL/lD;EAjL2mD;IAAI,YAAA;IAAW,WAAA;IAAW,YAAA;EAsLroD;AACF;AAvLopD;EAAuB;IAAG,UAAA;IAAU,WAAA;IAAW,YAAA;EA6LjsD;EA7L6sD;IAAI,YAAA;IAAW,WAAA;IAAW,YAAA;EAkMvuD;AACF;;AAhMA;EACI,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AAmMJ;;AAhMA;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EACA,yDAAA;AAmMJ;;AAhMA;EACI,yDAAA;AAmMJ;;AAjMA;EACI,yDAAA;AAoMJ;;AAlMA;EACI,6BAAA;EACA,qDAAA;EACA,qGAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;AAqMJ;;AAlMA;EACI,qBAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AAqMJ;;AAlMA;EACI,sBAAA;EACA,uBAAA;EACA,oBAAA;AAqMJ;;AAlMA;EACI,oBAAA;EACA,sBAAA;EACA,uBAAA;AAqMJ;;AAnMA;EACI,yDAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,2BAAA;AAsMJ;;AAnMA;EACI,aAAA;AAsMJ;;AAnMA;EACI,yDAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,2BAAA;AAsMJ;;AApMA;EACI,yDAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,2BAAA;AAuMJ;;AApMA;EACI,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,2CAAA;EACA,MAAA;AAuMJ;;AArMA;EACI,uBAAA;EACA,gDAAA;EACA,sCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,8GAAA;EACA,kBAAA;AAwMJ;;AAtMA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAyMJ;;AAvMA;EACI,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA0MJ;;AAxMA;EACI,cAAA;AA2MJ;;AAzMA;EACI,WAAA;AA4MJ;;AA1MA;EACI,gBAAA;AA6MJ;;AA3MA;EACI,YAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AA8MJ;;AA3MA;EACI,wCAAA;AA8MJ","sourcesContent":[".header-sec-sdk-{\r\n    font-family: \"Lato\", sans-serif;\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 0px 6px #a8c8dd;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 15px 20px;\r\n}\r\n.header-sec-sdk- .name-agent{\r\n    font-family: \"Lato\", sans-serif;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    color: #26344A;\r\n    line-height: 19px;\r\n    padding-left: 15px;\r\n}\r\n\r\n@-webkit-keyframes slideInRightVAbox {\r\n    0% {\r\n        -webkit-transform: translateX(100%);\r\n        transform: translateX(100%);\r\n        visibility: visible;\r\n    }\r\n    100% {\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n    }\r\n}\r\n@keyframes slideInRightVAbox {\r\n    0% {\r\n        -webkit-transform: translateX(100%);\r\n        transform: translateX(100%);\r\n        visibility: visible;\r\n    }\r\n    100% {\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n.initial-video-audio-container{\r\n    -webkit-animation-name: slideInRightVAbox;\r\n    animation-name: slideInRightVAbox;\r\n    -webkit-animation-duration: 1s;\r\n    animation-duration: 1s;\r\n    -webkit-animation-fill-mode: both;\r\n    animation-fill-mode: both;\r\n    right: 56px;\r\n    display: flex;\r\n    align-items: center;\r\n    z-index: 100000;\r\n    top: 118px;\r\n    position: fixed;\r\n    width: 340px;\r\n    border-radius: 4px;\r\n    border: 1px solid var(--gray-modern-200, #E3E8EF);\r\n    background: var(--gray-modern-100, #EEF2F6);\r\n    padding: 16px;\r\n    font-family: \"Inter\";\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n/* Co browser styles */\r\n.initial-video-audio-container.cobrowser-intial-width {\r\n    width: 270px;\r\n    margin: 16px auto;\r\n    position: fixed !important;\r\n    /* right: 30px !important; */\r\n    top: 130px !important;\r\n    z-index: 99999;\r\n    margin: 0;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    text-align: left;\r\n    border-radius: 6px;\r\n    background: var(--gray-modern-500,#697586);\r\n    width: 370px;\r\n    padding: 12px;\r\n}\r\n.initial-video-audio-container.cobrowser-intial-width .ad-img-block {\r\n    border: 0;\r\n    flex-shrink: 0;\r\n}\r\n.initial-video-audio-container.cobrowser-intial-width .ad-img-block img{\r\n    border: 0;\r\n}\r\n.initial-video-audio-container.cobrowser-intial-width .content-desc {\r\n    text-align: left;\r\n}\r\n.initial-video-audio-container.cobrowser-intial-width .content-desc .name {\r\n    color: var(--generic-white,#FFF);\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    line-height: 24px;\r\n    margin: 0;\r\n}\r\n.initial-video-audio-container.cobrowser-intial-width .content-desc .type-text {\r\n    color: var(--generic-white,#FFF);\r\n    font-size: 11px;\r\n    font-weight: 400;\r\n    line-height: 16px;\r\n}\r\n.initial-video-audio-container.cobrowser-intial-width .controls-v-a {\r\n    margin: 0;\r\n}\r\n.initial-video-audio-container.cobrowser-intial-width .controls-v-a img {\r\n    display: block;\r\n    margin: 0;\r\n}\r\n\r\n.cobrowse-toolbar {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    z-index: 100000;\r\n    cursor: move;\r\n    width : 40px;\r\n    height: 172px;\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);\r\n    border-radius: 2px;\r\n}\r\n.cobrowse-btn {\r\n    cursor: pointer;\r\n    width: 30px;\r\n    height: 30px;\r\n   \r\n    background: #F5F8FA;\r\n    border-radius: 2px;\r\n}\r\n.cobrowse-btn :hover {\r\n    background :#E9EFF4;\r\n}\r\n.toolbar-image {\r\n    width : 30px;\r\n    height : 30px\r\n}\r\n\r\n\r\n@-webkit-keyframes slideOutUpcobrowser {\r\n    0% {\r\n        -webkit-transform: translateY(60px);\r\n        transform: translateY(60px);\r\n        opacity: 0;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateY(0);\r\n        transform: translateY(0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes slideOutUpcobrowser {\r\n    0% {\r\n        -webkit-transform: translateY(60px);\r\n        transform: translateY(60px);\r\n        opacity: 0;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateY(0);\r\n        transform: translateY(0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.avatar-actions:hover .cobrowser-wrapper-elipse .elipse-btn {\r\n    display: block;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse {\r\n    position: absolute;\r\n    right: -25px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: auto;\r\n    height: auto;\r\n    top: auto;\r\n    bottom: 10px;\r\n    padding-left: 10px;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse.open-cobrowser .elipse-btn {\r\n    display: block !important;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse.open-cobrowser .co-bowser-options {\r\n    display: block;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse.open-input-browse .co-bowser-options .input-box-co-browser {\r\n    display: block;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .elipse-btn {\r\n    width: 20px;\r\n    height: 20px;\r\n    cursor: pointer;\r\n    display: none;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options {\r\n    position: absolute;\r\n    top: -78px;\r\n    left: -35px;\r\n    display: none;\r\n    -webkit-animation-name: slideOutUpcobrowser;\r\n    animation-name: slideOutUpcobrowser;\r\n    -webkit-animation-duration: 1s;\r\n    animation-duration: 1s;\r\n    -webkit-animation-fill-mode: both;\r\n    animation-fill-mode: both;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .btn-co-browser {\r\n    border-radius: 32px;\r\n    background: var(--bot-colors-intent,#4B4EDE);\r\n    box-shadow: 0px 2px 4px -2px rgba(16,24,40,0.1), 0px 4px 6px -1px rgba(16,24,40,0.1);\r\n    display: inline-flex;\r\n    height: 34px;\r\n    padding: 10px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n    border: 0;\r\n    width: 34px;\r\n    cursor: pointer;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser {\r\n    position: absolute;\r\n    bottom: auto;\r\n    top: -115px;\r\n    border-radius: 4px;\r\n    background: #FFF;\r\n    box-shadow: 0px 4px 6px -4px rgba(16,24,40,0.1), 0px 10px 15px -3px rgba(16,24,40,0.1);\r\n    display: flex;\r\n    width: 363px;\r\n    padding: 24px 12px;\r\n    flex-direction: column;\r\n    left: auto;\r\n    right: 0;\r\n    display: none;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser .label-text {\r\n    color: var(--neutral-900,#171717);\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    line-height: 20px;\r\n    margin-bottom: 4px;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input {\r\n    height: 40px;\r\n    padding: 8px 10px;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 24px;\r\n    width: 100%;\r\n    border-radius: 8px !important;\r\n    border: 1px solid var(--gray-300,#D0D5DD);\r\n    background: var(--base-white,#FFF);\r\n    box-shadow: 0px 1px 2px 0px rgba(16,24,40,0.05);\r\n    color: var(--gray-900,#101828);\r\n    outline: 0;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input::placeholder {\r\n    color: var(--gray-500,#667085);\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 24px;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:focus {\r\n    border: 1px solid var(--primary-300,#84ADFF);\r\n    box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16,24,40,0.05);\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:active {\r\n    border: 1px solid var(--primary-300,#84ADFF);\r\n    box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16,24,40,0.05);\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:disabled {\r\n    border: 1px solid var(--gray-300,#D0D5DD);\r\n    background: var(--gray-50,#F9FAFB);\r\n    pointer-events: none;\r\n    cursor: not-allowed;\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input.error {\r\n    border: 1px solid var(--error-300,#FDA29B);\r\n    background: var(--base-white,#FFF);\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input.error:focus {\r\n    box-shadow: 0px 0px 0px 4px #FEE4E2, 0px 1px 2px 0px rgba(16,24,40,0.05);\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:read-only {\r\n    border: 1px solid var(--gray-300,#D0D5DD);\r\n    background: var(--gray-50,#F9FAFB);\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser input:-moz-read-only {\r\n    border: 1px solid var(--gray-300,#D0D5DD);\r\n    background: var(--gray-50,#F9FAFB);\r\n}\r\n.avatar-actions .cobrowser-wrapper-elipse .co-bowser-options .input-box-co-browser .error-msg {\r\n    color: var(--error-500,#F04438);\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 20px;\r\n    margin-top: 4px;\r\n}\r\n/* End */\r\n\r\n.initial-video-audio-container .ad-img-block{\r\n    display: flex;\r\n    width: 40px;\r\n    height: 40px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: 6px;\r\n}\r\n.initial-video-audio-container .ad-img-block img{\r\n    width: 48px;\r\n    height: 48px;\r\n    border: 1px solid #fff;\r\n    border-radius: 100%;\r\n}\r\n.initial-video-audio-container .content-desc{\r\n    text-align: center;\r\n}\r\n.initial-video-audio-container .content-desc .name{\r\n    margin-bottom: 4px;\r\n    color: #000;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    line-height: normal;\r\n}\r\n.initial-video-audio-container .content-desc .type-text{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--gray-modern-500, #697586);\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n    gap: 5px;\r\n}\r\n.initial-video-audio-container .controls-v-a{\r\n    gap: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-top: 4px;\r\n}\r\n.initial-video-audio-container .controls-v-a button{\r\n    display: flex;\r\n    padding: 0px 12px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 6px;\r\n    border: 0;\r\n    color: var(--destructive-50, #FEF2F2);\r\n    text-align: center;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    line-height: normal;\r\n    height: 26px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n.initial-video-audio-container .controls-v-a button.decline-btn{\r\n    background: var(--destructive-500-main, #EF4444);\r\n}\r\n.initial-video-audio-container .controls-v-a button.accept-btn{\r\n    background: var(--success-600, #16A34A);\r\n}\r\n\r\n.video-audio-chat-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 4px;\r\n    border: 1px solid var(--gray-modern-200,#E3E8EF);\r\n    background: var(--gray-modern-100,#EEF2F6);\r\n}\r\n.video-audio-chat-container.video {\r\n    border: 0;\r\n}\r\n.video-audio-chat-container.video .video-chat- {\r\n    background: #000;\r\n}\r\n\r\n.video-audio-chat-container.video .video-chat- .video-view- .video-name-title {\r\n    color: #FFFFFF !important;\r\n}\r\n.video-audio-chat-container.video .video-chat- .video-view- .title {\r\n    color: #FFFFFF !important;\r\n}\r\n.video-audio-chat-container.video #callbuttons {\r\n    position: absolute;\r\n    bottom: 20px;\r\n}\r\n.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.active- .mute-audio {\r\n    background: var(--bot-colors-intent,#4B4EDE);\r\n    border: 1px solid var(--bot-colors-intent,#4B4EDE);\r\n}\r\n.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions .mute-audio {\r\n    background: rgba(255,255,255,0.3);\r\n    backdrop-filter: blur(2px);\r\n    border: 0 !important;\r\n}\r\n.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions .mute-audio .mute-img svg path {\r\n    fill: #fff;\r\n}\r\n.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video {\r\n    background: rgba(255,255,255,0.3);\r\n    backdrop-filter: blur(2px);\r\n}\r\n.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video {\r\n    background: var(--bot-colors-intent,#4B4EDE);\r\n    border: 1px solid var(--bot-colors-intent,#4B4EDE);\r\n    border: 0 !important;\r\n}\r\n.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video .video-mute svg path {\r\n    stroke: #fff;\r\n}\r\n.video-audio-chat-container.video #callbuttons .footer-btn-a-v-attch .btn_actions p {\r\n    color: var(--generic-white,#FFF);\r\n}\r\n.video-audio-chat-container .video-chat- {\r\n    width: 100%;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- {\r\n    width: 100%;\r\n    position: relative;\r\n    height: 250px;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view-.audio-view- {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    align-items: center;\r\n    padding: 16px;\r\n    height: auto;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view-.audio-view- .agent-profile-img {\r\n    display: flex;\r\n    width: 40px;\r\n    height: 40px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: 6px;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view-.audio-view- .agent-profile-img img {\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 100%;\r\n    border: 1px solid #fff;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view-.audio-view- .video-name-title {\r\n    color: #000;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    line-height: normal;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view-.audio-view- .title {\r\n    color: #000;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view-.audio-view- .audio-info {\r\n    color: var(--gray-modern-500,#697586);\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- video {\r\n    width: 100%;\r\n    border-radius: 4px;\r\n    background: #000;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container {\r\n    position: absolute;\r\n    width: 158px;\r\n    height: 60px;\r\n    cursor: move;\r\n    border-radius: 5px;\r\n    background: transparent;\r\n    z-index: 1;\r\n    top: 10px !important;\r\n    left: 0 !important;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container.minimize-video {\r\n    width: 40px !important;\r\n    height: 43px !important;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .close-video {\r\n    border-radius: 64px;\r\n    background: rgba(18,19,20,0.6);\r\n    display: flex;\r\n    width: 24px;\r\n    height: 24px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n    position: absolute;\r\n    top: -7px;\r\n    right: 25px;\r\n    cursor: pointer;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .close-video svg path {\r\n    fill: #fff;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video {\r\n    position: absolute;\r\n    bottom: 5px;\r\n    width: 34px;\r\n    height: 34px;\r\n    background: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 100%;\r\n    margin: 0 auto;\r\n    left: 0;\r\n    right: 0;\r\n    cursor: pointer;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video.off-on-action .t-off {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video.off-on-action .t-on {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video .t-off {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .turn-off-video .t-on {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .self-video {\r\n    border-radius: 4px;\r\n    box-shadow: 0px 25px 26px 0px rgba(32,33,36,0.17);\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .self-video .video-user-alphabet {\r\n    width: 35px;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: #FFBEB6;\r\n    border: 2px solid #fff;\r\n    border-radius: 100%;\r\n    color: #000000;\r\n    font-weight: bold;\r\n    font-size: 10px;\r\n    line-height: 29px;\r\n    margin: 0 auto;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    left: 10px;\r\n    bottom: 0;\r\n}\r\n.video-audio-chat-container .video-chat- .video-view- .self-video-container .self-video video {\r\n    width: 158px;\r\n    height: 60px;\r\n    background: transparent;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding-bottom: 16px;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 4px;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video {\r\n    border-radius: 50.82px;\r\n    display: flex;\r\n    width: 45px;\r\n    height: 30px;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 0;\r\n    background: var(--bot-colors-intent,#4B4EDE);\r\n    border: 1px solid var(--bot-colors-intent,#4B4EDE);\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video span {\r\n    line-height: 0px;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video span.video-unmute {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper .enable-video span.video-mute {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video {\r\n    border: 0.508px solid var(--neutral-300,#D4D4D4);\r\n    background: var(--kore-grey-kore-white,#FFF);\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video span.video-unmute {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- .enable-video span.video-mute {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- p.video-off {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper.active- p.video-on {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper p.video-off {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.video-btns-wrapper p.video-on {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- .mute-audio {\r\n    background: var(--bot-colors-intent,#4B4EDE);\r\n    border: 1px solid var(--bot-colors-intent,#4B4EDE);\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- .mute-audio span.mute-img {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- .mute-audio span.un-mute {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- p.mute-text {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions.active- p.un-mute-text {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .enable-audio {\r\n    display: flex;\r\n    width: 45px;\r\n    height: 30px;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 50.82px;\r\n    background: var(--destructive-500-main,#EF4444);\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions p {\r\n    color: var(--generic-black,#000);\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions p.mute-text {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions p.un-mute-text {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio {\r\n    border-radius: 50.82px;\r\n    border: 0.508px solid var(--neutral-300,#D4D4D4);\r\n    background: var(--kore-grey-kore-white,#FFF);\r\n    display: flex;\r\n    width: 45px;\r\n    height: 30px;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 0;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio span {\r\n    line-height: 0px;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio span.mute-img {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .footer-btn-a-v-attch .btn_actions .mute-audio span.un-mute {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    position: relative;\r\n    border-radius: var(--full, 9999px);\r\n    border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-utility-error-utility-error-200, #FECDCA);\r\n    background: var(--component-colors-utility-error-utility-error-50, #FEF3F2);\r\n    padding: var(--xxs, 2px) var(--default, 8px);\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info.recording-info-paused{\r\n    border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-utility-gray-utility-gray-200, #EAECF0);\r\n    background: var(--component-colors-utility-gray-utility-gray-50, #F9FAFB);\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info.recording-info-paused svg path{ \r\n    fill: #98A2B3;\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info.recording-info-paused p{\r\n    color: var(--component-colors-utility-gray-utility-gray-700, #344054);\r\n    text-align: center;\r\n    font-size: var(--font-size-text-xs, 12px);\r\n    font-weight: var(--font-weight-normal-Medium, 500);\r\n    line-height: var(--font-line-height-text-xs, 16px); /* 133.333% */\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info .recording-tooltip {\r\n    position: absolute;\r\n    top: -42px;\r\n    width: 180px;\r\n    left: -75px;\r\n    height: auto;\r\n    margin: 0 auto;\r\n    border-radius: var(--default, 8px);\r\n    background: var(--colors-background-bg-primary-solid, #0C111D);\r\n    padding: var(--default, 8px) var(--md, 12px);\r\n    color: var(--colors-text-text-white, #FFF);\r\n    text-align: center;\r\n    font-size: var(--font-size-text-xs, 12px);\r\n    font-weight: var(--font-weight-normal-Semibold, 600);\r\n    line-height: var(--font-line-height-text-xs, 16px);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info .recording-tooltip::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: -5px;\r\n    width: 10px;\r\n    height: 10px;\r\n    background: var(--colors-background-bg-primary-solid, #0C111D);\r\n    left: 96px;\r\n    margin: 0 auto;\r\n    transform: rotate(45deg);\r\n}\r\n\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info:hover .recording-tooltip {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info svg{\r\n    flex-shrink: 0;\r\n}\r\n\r\n.video-audio-chat-container .action-minimize-audio-control .recording-video-info p{\r\n    color: var(--component-colors-utility-error-utility-error-700, #B42318);\r\n    text-align: center;\r\n    font-size: var(--font-size-text-xs, 12px);\r\n    font-weight: var(--font-weight-normal-Medium, 500);\r\n    line-height: var(--font-line-height-text-xs, 16px);\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .maximize-video {\r\n    border-radius: 100%;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    width: 24px;\r\n    height: 24px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n    border-radius: 64px;\r\n    background: rgba(18,19,20,0.6);\r\n    margin: 0;\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .maximize-video .maximize-icon {\r\n    display: block;\r\n}\r\n.video-audio-chat-container .action-minimize-audio-control .maximize-video .minimize-icon {\r\n    display: none;\r\n}\r\n.video-audio-chat-container .show-self-video-container {\r\n    position: absolute;\r\n    top: 40px;\r\n    right: 10px;\r\n}\r\n.video-audio-chat-container .show-self-video-container .show-self-video {\r\n    border-radius: 100%;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    width: 24px;\r\n    height: 24px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n    border-radius: 64px;\r\n    background: rgba(18,19,20,0.6);\r\n    margin: 0;\r\n}\r\n\r\n#agentcontainer{\r\n    height: auto !important;\r\n}\r\n\r\n/*\n * Native fullscreen is requested on the chat window so call controls,\n * recording consent UI, and notifications remain in the fullscreen subtree.\n */\n.kore-chat-window:fullscreen {\n    width: 100%;\n    min-width: 0;\n    max-height: none;\n    height: 100%;\n    bottom: 0;\n    right: 0;\n    border: 0;\n    border-radius: 0;\n}\n\n.kore-chat-window:fullscreen #agentcontainer.full-screen-video {\n    top: 0;\n    left: 0;\n}\n\n#agentcontainer.full-screen-video {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100% !important;\r\n    z-index: 9;\r\n    padding: 0;\r\n}\r\n#callcontainer {\r\n    position: relative;\r\n    padding: 10px 16px 16px 16px;\r\n}\r\n#agentcontainer.full-screen-video #callcontainer {\r\n    height: 100%;\r\n    padding: 0;\r\n}\r\n#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container {\r\n    height: 100%;\r\n}\r\n#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- {\r\n    height: 100%;\r\n}\r\n#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- #audiovideocallcontainer {\r\n    height: 100%;\r\n}\r\n#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- #audiovideocallcontainer .video-view- {\r\n    height: 100%;\r\n}\r\n#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .video-chat- #audiovideocallcontainer .video-view- video {\r\n    height: 100%;\r\n    /* background: linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0) 68.49%,#000 100%); */\r\n}\r\n#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .action-minimize-audio-control .maximize-video .maximize-icon {\r\n    display: none;\r\n}\r\n#agentcontainer.full-screen-video #callcontainer .video-audio-chat-container .action-minimize-audio-control .maximize-video .minimize-icon {\r\n    display: block;\r\n}\r\n\r\n.system-template {\r\n    position: relative;\r\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);\r\n    margin-bottom: 30px;\r\n    font-weight: 400;\r\n    margin-top: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.system-template-msg {\r\n    position: relative;\r\n    top: 8px;\r\n    background: var(--sdk-chat-widow-default-white);\r\n    padding: 0px 10px;\r\n    display: initial;\r\n    width: 137px;\r\n    color: #333;\r\n    margin-left: 0;\r\n    margin-top: 43x;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n}\r\n\r\n.agent-mouse {\r\n    position: absolute;\r\n    z-index:10000;\r\n    width: 20px;\r\n    height: 20px;\r\n    transition: left .05s linear,top .05s linear;\r\n    background-size: contain;\r\n    background-position: 50%;\r\n    background-repeat: no-repeat;\r\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwMCIgd2lkdGg9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkYXRhLW5hbWU9IkxheWVyIDEiIHZpZXdCb3g9IjAgMCA1MCA1MCI+PHBhdGggZD0iTTQ4LjcxIDQyLjkxTDM0LjA4IDI4LjI5IDQ0LjMzIDE4YTEgMSAwIDAwLS4zMy0xLjYxTDIuMzUgMS4wNmExIDEgMCAwMC0xLjI5IDEuMjlMMTYuMzkgNDRhMSAxIDAgMDAxLjY1LjM2bDEwLjI1LTEwLjI4IDE0LjYyIDE0LjYzYTEgMSAwIDAwMS40MSAwbDQuMzgtNC4zOGExIDEgMCAwMC4wMS0xLjQyem0tNS4wOSAzLjY3TDI5IDMyYTEgMSAwIDAwLTEuNDEgMGwtOS44NSA5Ljg1TDMuNjkgMy42OWwzOC4xMiAxNEwzMiAyNy41OEExIDEgMCAwMDMyIDI5bDE0LjU5IDE0LjYyeiIvPjwvc3ZnPg==\");\r\n    border-color: transparent;\r\n}\r\n.agent-mouse-circle {\r\n    content: \"\";\r\n    display: inline-block;\r\n    width: 20px;\r\n    height: 20px;\r\n    background: #4950f6;\r\n    border-radius: 100%;\r\n    transform: translate(-50%,-50%);\r\n    opacity: .3;\r\n}\r\n\r\n.rr-block {\r\n    border: 1px solid red !important;\r\n    background: transparent;\r\n}\r\n\r\n.agent-bot {\r\n    display: block;\r\n    background: #009dab;\r\n    -webkit-border-radius: 50%;\r\n    -moz-border-radius: 50%;\r\n    border-radius: 50%;\r\n    padding: 6px;\r\n    width: 36px;\r\n    height: 36px;\r\n    cursor: pointer;\r\n    position: fixed;\r\n    right: 0;\r\n}\r\n/*********************** rrweb css ******************************************/\r\n.replayer-wrapper{position:relative}.replayer-mouse{position:absolute;width:20px;height:20px;transition:left .05s linear,top .05s linear;background-size:contain;background-position:50%;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwMCIgd2lkdGg9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkYXRhLW5hbWU9IkxheWVyIDEiIHZpZXdCb3g9IjAgMCA1MCA1MCI+PHBhdGggZD0iTTQ4LjcxIDQyLjkxTDM0LjA4IDI4LjI5IDQ0LjMzIDE4YTEgMSAwIDAwLS4zMy0xLjYxTDIuMzUgMS4wNmExIDEgMCAwMC0xLjI5IDEuMjlMMTYuMzkgNDRhMSAxIDAgMDAxLjY1LjM2bDEwLjI1LTEwLjI4IDE0LjYyIDE0LjYzYTEgMSAwIDAwMS40MSAwbDQuMzgtNC4zOGExIDEgMCAwMC4wMS0xLjQyem0tNS4wOSAzLjY3TDI5IDMyYTEgMSAwIDAwLTEuNDEgMGwtOS44NSA5Ljg1TDMuNjkgMy42OWwzOC4xMiAxNEwzMiAyNy41OEExIDEgMCAwMDMyIDI5bDE0LjU5IDE0LjYyeiIvPjwvc3ZnPg==\");border-color:transparent}.replayer-mouse:after{content:\"\";display:inline-block;width:20px;height:20px;background:#4950f6;border-radius:100%;transform:translate(-50%,-50%);opacity:.3}.replayer-mouse.active:after{animation:click .2s ease-in-out 1}.replayer-mouse.touch-device{background-image:none;width:70px;height:70px;border-radius:100%;margin-left:-37px;margin-top:-37px;border:4px solid rgba(73,80,246,0);transition:left 0s linear,top 0s linear,border-color .2s ease-in-out}.replayer-mouse.touch-device.touch-active{border-color:#4950f6;transition:left .25s linear,top .25s linear,border-color .2s ease-in-out}.replayer-mouse.touch-device:after{opacity:0}.replayer-mouse.touch-device.active:after{animation:touch-click .2s ease-in-out 1}.replayer-mouse-tail{position:absolute;pointer-events:none}@keyframes click{0%{opacity:.3;width:20px;height:20px}50%{opacity:.5;width:10px;height:10px}}@keyframes touch-click{0%{opacity:0;width:20px;height:20px}50%{opacity:.5;width:10px;height:10px}}\r\n/*# sourceMappingURL=rrweb.min.css.map */\r\n\r\n.kore-chat-window ul.chat-container li.fromCurrentUser .extra-info{\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n    flex-direction: row-reverse;\r\n}\r\n\r\nli.fromCurrentUser .sentIndicator{\r\n    position: relative;\r\n    top: 1px;\r\n    margin-right: 5px;\r\n    width: 12px;\r\n    height: 12px;\r\n    background-size: 100%;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMy4yNSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9hbmd1bGFyXzEwNzJfNTIzNDMpIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8ZGVmcz4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDBfYW5ndWxhcl8xMDcyXzUyMzQzIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkgcm90YXRlKC0xODApIHNjYWxlKDQpIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzlBQTRCMiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5QUE0QjIiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=\");\r\n}\r\n    \r\nli.fromCurrentUser .sentIndicator.delivered{\r\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgOEM2LjIwOTE0IDggOCA2LjIwOTE0IDggNEM4IDEuNzkwODYgNi4yMDkxNCAwIDQgMEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNEMwIDYuMjA5MTQgMS43OTA4NiA4IDQgOFpNNS44NTM1NSAzLjM1MzU1QzYuMDQ4ODIgMy4xNTgyOSA2LjA0ODgyIDIuODQxNzEgNS44NTM1NSAyLjY0NjQ1QzUuNjU4MjkgMi40NTExOCA1LjM0MTcxIDIuNDUxMTggNS4xNDY0NSAyLjY0NjQ1TDMuNSA0LjI5Mjg5TDIuODUzNTUgMy42NDY0NUMyLjY1ODI5IDMuNDUxMTggMi4zNDE3MSAzLjQ1MTE4IDIuMTQ2NDUgMy42NDY0NUMxLjk1MTE4IDMuODQxNzEgMS45NTExOCA0LjE1ODI5IDIuMTQ2NDUgNC4zNTM1NUwzLjE0NjQ1IDUuMzUzNTVDMy4zNDE3MSA1LjU0ODgyIDMuNjU4MjkgNS41NDg4MiAzLjg1MzU1IDUuMzUzNTVMNS44NTM1NSAzLjM1MzU1WiIgZmlsbD0iIzlBQTRCMiIvPgo8L3N2Zz4K\");\r\n}\r\nli.fromCurrentUser .sentIndicator.read{\r\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgOEM2LjIwOTE0IDggOCA2LjIwOTE0IDggNEM4IDEuNzkwODYgNi4yMDkxNCAwIDQgMEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNEMwIDYuMjA5MTQgMS43OTA4NiA4IDQgOFpNNS44NTM1NSAzLjM1MzU1QzYuMDQ4ODIgMy4xNTgyOSA2LjA0ODgyIDIuODQxNzEgNS44NTM1NSAyLjY0NjQ1QzUuNjU4MjkgMi40NTExOCA1LjM0MTcxIDIuNDUxMTggNS4xNDY0NSAyLjY0NjQ1TDMuNSA0LjI5Mjg5TDIuODUzNTUgMy42NDY0NUMyLjY1ODI5IDMuNDUxMTggMi4zNDE3MSAzLjQ1MTE4IDIuMTQ2NDUgMy42NDY0NUMxLjk1MTE4IDMuODQxNzEgMS45NTExOCA0LjE1ODI5IDIuMTQ2NDUgNC4zNTM1NUwzLjE0NjQ1IDUuMzUzNTVDMy4zNDE3MSA1LjU0ODgyIDMuNjU4MjkgNS41NDg4MiAzLjg1MzU1IDUuMzUzNTVMNS44NTM1NSAzLjM1MzU1WiIgZmlsbD0iIzIyQzU1RSIvPgo8L3N2Zz4K\");\r\n}\r\n#cobrowse-toolbar.rr-block {\r\n    border-radius: 6px !important;\r\n    background: var(--gray-modern-50, #F8FAFC) !important;\r\n    box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.1), 0px 4px 6px -1px rgba(16, 24, 40, 0.1) !important;\r\n    padding: 0 !important;\r\n    height: auto !important;\r\n    display: flex !important;\r\n    padding: 12px 8px !important;\r\n    flex-direction: column;\r\n    align-items: center !important;\r\n    gap: 16px;\r\n}\r\n\r\n#cobrowse-toolbar.rr-block[do-not-mutate] [do-not-mutate] {\r\n    padding: 0 !important;\r\n    background: transparent !important;\r\n    width: 16px !important;\r\n    height: 16px !important;\r\n    margin: 0 auto !important;\r\n}\r\n\r\n#cobrowse-toolbar.rr-block[do-not-mutate] [do-not-mutate] img{\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    margin: 0 !important;\r\n}\r\n\r\n.kore-chat-window-main-section.minimize-chat .chat-widgetwrapper-main-container.rr-block {\r\n    border: 0 !important;\r\n    width: auto !important;\r\n    height: auto !important;      \r\n}\r\ndiv .agent-bubble-comp .agent-bubble-content .bottom-info .sent{\r\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMy4yNSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9hbmd1bGFyXzEwNzJfNTIzNDMpIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8ZGVmcz4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDBfYW5ndWxhcl8xMDcyXzUyMzQzIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkgcm90YXRlKC0xODApIHNjYWxlKDQpIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzlBQTRCMiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5QUE0QjIiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=\");\r\n    width: 8px;\r\n    height: 8px;\r\n    background-repeat: no-repeat;\r\n    background-position: center\r\n}\r\n\r\ndiv .agent-bubble-comp .agent-bubble-content .bottom-info .sent.hide{\r\n    display: none;\r\n}\r\n\r\ndiv .agent-bubble-comp .agent-bubble-content .bottom-info .delivered{\r\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgOEM2LjIwOTE0IDggOCA2LjIwOTE0IDggNEM4IDEuNzkwODYgNi4yMDkxNCAwIDQgMEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNEMwIDYuMjA5MTQgMS43OTA4NiA4IDQgOFpNNS44NTM1NSAzLjM1MzU1QzYuMDQ4ODIgMy4xNTgyOSA2LjA0ODgyIDIuODQxNzEgNS44NTM1NSAyLjY0NjQ1QzUuNjU4MjkgMi40NTExOCA1LjM0MTcxIDIuNDUxMTggNS4xNDY0NSAyLjY0NjQ1TDMuNSA0LjI5Mjg5TDIuODUzNTUgMy42NDY0NUMyLjY1ODI5IDMuNDUxMTggMi4zNDE3MSAzLjQ1MTE4IDIuMTQ2NDUgMy42NDY0NUMxLjk1MTE4IDMuODQxNzEgMS45NTExOCA0LjE1ODI5IDIuMTQ2NDUgNC4zNTM1NUwzLjE0NjQ1IDUuMzUzNTVDMy4zNDE3MSA1LjU0ODgyIDMuNjU4MjkgNS41NDg4MiAzLjg1MzU1IDUuMzUzNTVMNS44NTM1NSAzLjM1MzU1WiIgZmlsbD0iIzlBQTRCMiIvPgo8L3N2Zz4K\");\r\n    width: 8px;\r\n    height: 8px;\r\n    background-repeat: no-repeat;\r\n    background-position: center\r\n}\r\ndiv .agent-bubble-comp .agent-bubble-content .bottom-info .read{\r\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgOEM2LjIwOTE0IDggOCA2LjIwOTE0IDggNEM4IDEuNzkwODYgNi4yMDkxNCAwIDQgMEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNEMwIDYuMjA5MTQgMS43OTA4NiA4IDQgOFpNNS44NTM1NSAzLjM1MzU1QzYuMDQ4ODIgMy4xNTgyOSA2LjA0ODgyIDIuODQxNzEgNS44NTM1NSAyLjY0NjQ1QzUuNjU4MjkgMi40NTExOCA1LjM0MTcxIDIuNDUxMTggNS4xNDY0NSAyLjY0NjQ1TDMuNSA0LjI5Mjg5TDIuODUzNTUgMy42NDY0NUMyLjY1ODI5IDMuNDUxMTggMi4zNDE3MSAzLjQ1MTE4IDIuMTQ2NDUgMy42NDY0NUMxLjk1MTE4IDMuODQxNzEgMS45NTExOCA0LjE1ODI5IDIuMTQ2NDUgNC4zNTM1NUwzLjE0NjQ1IDUuMzUzNTVDMy4zNDE3MSA1LjU0ODgyIDMuNjU4MjkgNS41NDg4MiAzLjg1MzU1IDUuMzUzNTVMNS44NTM1NSAzLjM1MzU1WiIgZmlsbD0iIzIyQzU1RSIvPgo8L3N2Zz4K\");\r\n    width: 8px;\r\n    height: 8px;\r\n    background-repeat: no-repeat;\r\n    background-position: center\r\n}\r\n\r\n.campaign-calling-audio-static-wrapper {\r\n    margin: 4px 16px;\r\n    display: flex;\r\n    padding: 16px;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    align-self: stretch;\r\n    border-radius: 8px;\r\n    border: 1px solid var(--Gray-Modern-200, #e3e8ef);\r\n    background: var(--Gray-Modern-100, #eef2f6);\r\n    gap: 0;\r\n}\r\n.campaign-calling-audio-static-wrapper .icon_block {\r\n    border-radius: 58.333px;\r\n    border: 2.333px solid var(--Generic-White, #fff);\r\n    background: var(--Primary-50, #eaf1fc);\r\n    display: flex;\r\n    width: 40px;\r\n    height: 40px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-shadow: 0px 2.333px 3.5px -2.333px rgba(16, 24, 40, 0.10), 0px 5.833px 8.75px -1.75px rgba(16, 24, 40, 0.10);\r\n    margin-bottom: 6px;\r\n}\r\n.campaign-calling-audio-static-wrapper h1 {\r\n    color: #000;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    line-height: normal;\r\n    text-align: center;\r\n}\r\n.campaign-calling-audio-static-wrapper p {\r\n    display: flex;\r\n    align-items: center;\r\n    color: var(--Gray-Modern-500, #697586);\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n    gap: 6px;\r\n    margin-top: 4px;\r\n}\r\n.campaign-calling-audio-static-wrapper p svg {\r\n    flex-shrink: 0;\r\n}\r\n.campaign-calling-audio-static-wrapper p span {\r\n    width: 100%;\r\n}\r\n.campaign-calling-audio-static-wrapper .button-cancel-div {\r\n    margin-top: 12px;\r\n}\r\n.campaign-calling-audio-static-wrapper .button-cancel-div .btn-cancel-btn {\r\n    height: 30px;\r\n    min-width: 110px;\r\n    color: var(--Primary-600, #155eef);\r\n    text-align: center;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    line-height: 18px;\r\n    border: 0;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    padding: 0;\r\n}\r\n\r\nhtml.rrweb-paused * {\r\n    animation-play-state: running !important\r\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
